import { useQuery } from '@tanstack/react-query';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { DataRoomVisitStat } from 'router/subrouters/DataRoom/models/Dashboard';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { getMixpanelErrorProps } from 'axiosUtils';
import { ErrorViewedProps } from 'models/MixpanelEvents';

const VISIT_STATS_QUERY_KEY = 'data-room-visit-stats';

type UseVisitStatsQueryProps = {
  dataRoomId?: string;
};

export default function useVisitStatsQuery({
  dataRoomId,
}: UseVisitStatsQueryProps) {
  const getMixpanelProps = useGetMixpanelProps();

  const query = useQuery<DataRoomVisitStat[]>({
    queryKey: [VISIT_STATS_QUERY_KEY, { dataRoomId }],
    queryFn: async () => {
      const { data } = await dataRoomApi.room.getVisitStats(dataRoomId);

      return data;
    },
    onError: (error) =>
      mixpanelService.errorViewed(
        getMixpanelProps(getMixpanelErrorProps(error)) as ErrorViewedProps,
      ),
    enabled: !!dataRoomId,
  });

  useInvalidateQueryOnUnmount(VISIT_STATS_QUERY_KEY);

  return query;
}
